import { FormType } from '../../../form-types';
import { WeightManagementFollowupFieldAnswers } from '../questions';

export const weightMngFollowup: FormType<WeightManagementFollowupFieldAnswers> = {
  name: 'Weight Management Follow Up',
  questions: [
    'weightMngFollowup_sex',
    'weightMngFollowup_weightHeightBMI',
    {
      key: 'weightMngFollowup_healthChanges',
      next: {
        condition: { 'weightMngFollowup_healthChanges.yes': true },
        key: 'weightMngFollowup_healthChangesDetails',
        els: 'weightMngFollowup_medicationResponse'
      }
    },
    'weightMngFollowup_healthChangesDetails',
    {
      key: 'weightMngFollowup_medicationResponse',
      next: {
        condition: { 'weightMngFollowup_medicationResponse.not_well': true },
        key: 'weightMngFollowup_medicationResponseDetails',
        els: 'weightMngFollowup_sideEffects'
      }
    },
    'weightMngFollowup_medicationResponseDetails',
    {
      key: 'weightMngFollowup_sideEffects',
      next: {
        condition: { 'weightMngFollowup_sideEffects.yes': true },
        key: 'weightMngFollowup_sideEffectsDetails',
        els: 'weightMngFollowup_treatmentPreference'
      }
    },
    'weightMngFollowup_sideEffectsDetails',
    'weightMngFollowup_treatmentPreference',
    'weightMngFollowup_additionalQuestions',
    {
      key: 'weightMngFollowup_truthfulnessConsent',
      next: {
        condition: { 'weightMngFollowup_truthfulnessConsent.non_consent': true },
        key: 'weightMngFollowup_ineligible',
        els: 'weightMngFollowup_treatmentConsent'
      }
    },
    {
      key: 'weightMngFollowup_treatmentConsent',
      next: {
        condition: { 'weightMngFollowup_treatmentConsent.non_consent': true },
        key: 'weightMngFollowup_ineligible',
        els: 'weightMngFollowup_complete'
      }
    },
    'weightMngFollowup_ineligible',
    'weightMngFollowup_complete'
  ]
};
